var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#100F15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0186 14.6787L17.3236 11.9837L19.2716 10.0347L21.9656 12.7287L20.0186 14.6787ZM13.0796 21.6247L10.1026 21.8957L10.3666 18.9397L15.9836 13.3227L18.6796 16.0187L13.0796 21.6247ZM23.4036 11.3377L23.4026 11.3367L20.6646 8.59867C19.9236 7.85967 18.6506 7.82467 17.9486 8.52967L8.95259 17.5257C8.62659 17.8507 8.42459 18.2827 8.38259 18.7397L8.00359 22.9097C7.97759 23.2047 8.08259 23.4967 8.29259 23.7067C8.48159 23.8957 8.73659 23.9997 8.99959 23.9997C9.03059 23.9997 9.06059 23.9987 9.09059 23.9957L13.2606 23.6167C13.7186 23.5747 14.1496 23.3737 14.4746 23.0487L23.4716 14.0517C24.1996 13.3217 24.1686 12.1037 23.4036 11.3377Z",
    fill: "#100F15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.ac824377ea30f3be62ed72e35d560b70.svg";
export { ForwardRef as ReactComponent };